import { render, staticRenderFns } from "./UpdateStatus.vue?vue&type=template&id=6d15ff9a&"
import script from "./UpdateStatus.vue?vue&type=script&lang=js&"
export * from "./UpdateStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports